import { render } from "./FakeSelect.vue?vue&type=template&id=077bc7ca"
import script from "./FakeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FakeSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/FakeSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "077bc7ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('077bc7ca', __exports__)) {
    api.reload('077bc7ca', __exports__)
  }
  
  module.hot.accept("./FakeSelect.vue?vue&type=template&id=077bc7ca", () => {
    api.rerender('077bc7ca', render)
  })

}


export default __exports__